import React from 'react';

import { Button } from '@mui/material';

import { usePromoHeal } from '~/hooks/usePromoHeal';

import { PromoWarning } from '~/services/PromoService';

interface PromoWarningActionProps {
  promoWarning: PromoWarning;
  promoCodeName: string;
}

const PromoWarningAction = ({ promoWarning, promoCodeName }: PromoWarningActionProps) => {
  const { healPromo, isHealing } = usePromoHeal();

  switch (promoWarning.code) {
    case 'PROMO_CONDITION_WITH_DISCOUNT_IDS_THAT_DOES_NOT_EXIST':
    case 'PROMO_CONDITION_DISCOUNT_ID_MISMATCH':
      return (
        <Button onClick={() => healPromo({ targetPromoCodeName: promoCodeName })} disabled={isHealing} color="primary">
          {isHealing ? 'Healing...' : 'Heal Promo'}
        </Button>
      );
    default:
      return <div>{JSON.stringify(promoWarning.metadata, null, 2)}</div>;
  }
};

export default PromoWarningAction;
